import Button from '../../../components/Button'
import Rules from '../../../components/Rules'
import SearchField from '../../../components/SearchField'
import {
    FlexBox,
    FlexLeft,
    FlexRight,
    SectionFiltersGrid
} from '../../../components/UtilsResponsive/UtilsResponsive.style'
import { controlList } from '../storage'
import useSubmit from '../useSubmit'

export default function SearchBrands() {
    const { props } = controlList.useSearch()
    const open = useSubmit()
    return (
        <SectionFiltersGrid>
            <SearchField
                {...props}
                placeholder="Buscar por código o nombre de la marca"
                size="auto"
                fullWidth={true}
            />
            <FlexBox>
                <FlexLeft></FlexLeft>
                <FlexRight>
                    <Rules cu="CU036">
                        <Button size="sm" onClick={() => open()}>
                            Nuevo
                        </Button>
                    </Rules>
                </FlexRight>
            </FlexBox>
        </SectionFiltersGrid>
    )
}
